
  import { Device } from '@twilio/voice-sdk';
  export default {
    mounted() {
      const device = new Device(this.el.dataset.token);
    }

  }
